module.exports = __webpack_public_path__ + "fonts/latoitalic.7582e823.ttf";